
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import 'antd/dist/reset.css';
import '@/styles/globals.css';
import { store } from '@/AppRedux/store';
import { IntlProviderWrapper } from '@/modules/i18n/IntlProviderWrapper';
import ThemeConfigProvider from '@/modules/theme/ThemeConfigProvider';

const rawBase = import.meta.env.VITE_BASE || '/';

// ถ้าเป็น "/" หรือเว้นว่าง → ให้เป็น undefined (คือไม่มี basename)
const basename = !rawBase || rawBase === '/' ? undefined : rawBase.replace(/\/$/, '')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeConfigProvider>
        <IntlProviderWrapper>
          <BrowserRouter basename={basename}>
            <App />
          </BrowserRouter>
        </IntlProviderWrapper>
      </ThemeConfigProvider>
    </Provider>
  </React.StrictMode>
);
